import { Elements } from "@stripe/react-stripe-js";
import React from "react";
import { connect } from 'react-redux';
import StripeForm from "./StripeForm";
import { paymentFormSubmit, paymentIsProcessingAsync } from "../../../actions/creators/checkout/payment";
import { getCheckoutPaymentConstraints, getUserInfo, getCheckoutContext, getStripePaymentIntentClientSecret, getStripePaymentIntentReturnUrl, getStripePaymentIntentTransactionId } from "../../../reducers";
import { PaymentConstraint } from "./interfaces";
import { createStripePaymentIntent } from "../../../actions/creators/checkout/stripe";
import { dialogAlert } from "../../../actions/creators/dialogs";

interface Props {
    cash: number,
    clientSecret?: string,
    constraints: Array<PaymentConstraint>,
    context: string,
    returnUrl?: string,
    transactionId?: string,
    userInfo: object,
    createPaymentIntent: Function,
    dialogAlert: Function,
    onCancel: Function,
    transactionData?: {
        context: string,
        data: { [key: string]: any },
    }
    waitForPaymentResult: Function,
}

declare const window: {localConfig: any};

class StripeElements extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.createPaymentIntent = this.createPaymentIntent.bind(this);
    }

    componentDidMount(): void {
        this.createPaymentIntent();
    }

    createPaymentIntent(params?: any) {
        if (!params) {
            params = {};
        }

        if (this.props.transactionData) {
            params = Object.assign({}, this.props.transactionData, params);
        }

        return this.props.createPaymentIntent(params);
    }

    render() {
        const stripePromise = window.localConfig.stripe.promise;

        if (!stripePromise || !this.props.clientSecret) {
            return null;
        }

        const allowedCardBrands: string[] = [];

        this.props.constraints.forEach(constraint => {
            if ('card_brand' in constraint && constraint.card_brand) {
                allowedCardBrands.push(constraint.card_brand);
            }
        });

        const bodyStyle = getComputedStyle(document.body);
        const textColor = bodyStyle.getPropertyValue('--text-primary');
        const bgColor = bodyStyle.getPropertyValue('--page-bg');
        const colorStatusSafe = bodyStyle.getPropertyValue('--color-status-safe');
        const colorStatusDanger = bodyStyle.getPropertyValue('--color-status-danger');
        const colorError = bodyStyle.getPropertyValue('--accent');

        return <Elements stripe={stripePromise} options={{
            clientSecret: this.props.clientSecret,
            locale: 'es',
            fonts: [{
                family: 'MaisonNeue',
                src: 'url(https://statics.cinemex.com/uploads/cms/attachments/672a8237bcc5a.woff)',
                weight: '400',
            }],
            appearance: {
                theme: document.body.classList.contains('theme-market') ? 'night' : 'stripe',
                variables: {
                    borderRadius: '0',
                    colorBackground: bgColor,
                    colorPrimary: textColor,
                    colorText: textColor,
                    colorSuccess: colorStatusSafe,
                    colorWarning: colorStatusDanger,
                    fontFamily: 'Maison Neue, sans-serif',
                    gridRowSpacing: '1rem',
                },
                rules: {
                    '.Input': {
                        backgroundColor: bgColor,
                        border: 'none',
                        borderBottom: `1px solid ${textColor}`,
                        borderRadius: '0',
                        padding: '0.5rem 0',
                        boxShadow: 'none',
                        outline: 'none',
                    },
                    '.Input:focus': {
                        borderBottom: `1px solid ${textColor}`,
                        boxShadow: 'none',
                        outline: 'none',
                    },
                    '.Input--invalid': {
                        borderBottom: `1px solid ${colorStatusDanger}`,
                        boxShadow: 'none',
                    },
                    '.Label': {
                        color: textColor,
                        fontWeight: '700',
                        marginTop: '9px',
                    },
                    '.Error': {
                        color: colorError,
                        padding: '0.5rem 0',
                    },
                }
            },
            // @ts-ignore
            allowedCardBrands,
            paymentMethodCreation: 'manual',
        }}>
            <StripeForm
                clientSecret={this.props.clientSecret}
                context={this.props.context}
                createPaymentIntent={this.createPaymentIntent}
                returnUrl={this.props.returnUrl}
                transactionId={this.props.transactionId}
                user={this.props.userInfo}
                onError={message => this.props.dialogAlert(message)}
                waitForPaymentResult={this.props.waitForPaymentResult}
            />
        </Elements>;
    }
}

const mapStateToProps = (state, props) => ({
    clientSecret: getStripePaymentIntentClientSecret(state),
    constraints: getCheckoutPaymentConstraints(state),
    context: ('context' in props) ? props.context : getCheckoutContext(state),
    returnUrl: getStripePaymentIntentReturnUrl(state),
    transactionId: getStripePaymentIntentTransactionId(state),
    userInfo: ('userInfo' in props) ? props.userInfo : getUserInfo(state),
});

const mapDispatchToProps = (dispatch, props) => ({
    dialogAlert: (message) => dispatch(dialogAlert(message)),
    createPaymentIntent: params => dispatch(createStripePaymentIntent(params)),
    waitForPaymentResult: (transactionId: string) => dispatch(paymentIsProcessingAsync({transactionId, context: props.context})),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StripeElements);